import scarfClient from "@/services/scarfClient";

const ScarfClientService = {
  Cadastrar() {
    return new Promise((resolve, reject) => {
      scarfClient
        .post("/Biometria/Cadastrar")
        .then((response) => {
          let result = response.data;
          if (!result) {
            result = { Iniciado: false, PagamentosPendentes: [] };
          }

          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },

  Capturar() {
    return new Promise((resolve, reject) => {
      scarfClient
        .post("/Biometria/Capturar")
        .then((response) => {
          let result = response.data;
          if (!result) {
            result = { Iniciado: false, PagamentosPendentes: [] };
          }

          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },

  Verificar(request) {
    return new Promise((resolve, reject) => {
      scarfClient
        .post("/Biometria/Verificar", request)
        .then((response) => {
          let result = response.data;
          if (!result) {
            result = { Iniciado: false, PagamentosPendentes: [] };
          }

          return resolve(result);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  },
};

export default ScarfClientService;
